<div class="custom-stepper">
    <p class="stepper-header" role="status" aria-live="polite" *ngIf="showStepTitle && currentStepTitle" [attr.aria-label]="currentStepTitle">{{ currentStepTitle }}</p>
    <nav aria-label="Application progress">
        <div class="stepper-horizontal" id="stepper" role="list">
            <ng-container *ngFor="let step of mainSteps">
                <div class="step" role="listitem"
                     [class.editing]="isStepEdit(step.id)"
                     [class.active]="isStepActive(step.id)"
                     [class.done]="isStepDone(step.id)"
                     [attr.aria-current]="isStepActiveSR(step.id) ? 'step' : null">
                    <div class="step-circle" aria-hidden="true">
                        <div class="step-inner-circle">
                            <span class="step-number" *ngIf="!isStepDone(step.id)">
                                {{ step.id }}
                            </span>
                            <img width="12" alt="" *ngIf="isStepDone(step.id)" [src]="checkIconUrl">
                        </div>
                    </div>

                    <div class="step-title" aria-hidden="true">
                        {{ step.title }}
                    </div>

                    <span class="visually-hidden">
                        Step {{ step.id }} of {{ mainSteps.length }}: {{ step.title }}<ng-container *ngIf="isStepDoneSR(step.id)">, completed</ng-container><ng-container *ngIf="isStepActiveSR(step.id)">, current step</ng-container>
                    </span>

                    <div class="step-bar-left" aria-hidden="true">
                    </div>
                </div>
            </ng-container>
        </div>
    </nav>
</div>
